import css from "styled-jsx/css";

export const componentStyles = css.global`
  .product-card-content {
    display: flex;
    flex-direction: column;

    .content-title {
      font-size: 2rem;
      line-height: 2.375rem;
      font-weight: 600;
    }
  }
`;
